exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-new-personal-consultation-component .help p.success{color:#48c78e}.modal-new-personal-consultation-component .help p.danger{color:#f14668}.modal-new-personal-consultation-component .help p .icon{margin-left:8px;width:auto}.modal-new-personal-consultation-component .help p .icon .mdi:before{font-size:12px}.modal-new-personal-consultation-component .content-btn{margin-top:20px;text-align:right}.modal-new-personal-consultation-component .content-wrap{margin-top:30px}.modal-new-personal-consultation-component .modal-card-body{padding:2.4rem}", ""]);

// exports
